import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "@/components/ui/dialog";

const MEN = [
  ["S", "36-38", "38-40", "26-28"],
  ["M", "38-40", "40-42", "28-30"],
  ["L", "40-42", "42-44", "30-32"],
  ["XL", "42-44", "44-46", "32-34"],
  ["XXL", "44-46", "46-48", "34-36"],
];
const BOYS = [
  ["2-3Y", "22", "23", "18"],
  ["4-5Y", "24", "25", "20"],
  ["6-7Y", "26", "27", "22"],
  ["8-9Y", "28", "29", "24"],
  ["10-11Y", "30", "31", "26"],
];

export function SizeChartModal({ audience = "men", trigger }) {
  const rows = audience === "boys" ? BOYS : MEN;
  return (
    <Dialog>
      <DialogTrigger asChild data-testid="size-chart-trigger">{trigger}</DialogTrigger>
      <DialogContent className="bg-[#FBF7DE] border-[var(--line)] max-w-lg">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl text-[var(--bronze)]">Size Guide</DialogTitle>
        </DialogHeader>
        <p className="text-sm text-[var(--olive)]">All measurements in inches. Choose a relaxed fit for festive comfort.</p>
        <table className="w-full text-sm mt-2">
          <thead>
            <tr className="uplabel text-[0.6rem] border-b border-[var(--line)]">
              <th className="text-left py-2">Size</th>
              <th className="text-left py-2">Chest</th>
              <th className="text-left py-2">Length</th>
              <th className="text-left py-2">Shoulder</th>
            </tr>
          </thead>
          <tbody>
            {rows.map((r) => (
              <tr key={r[0]} className="border-b border-[var(--line)]/50 text-[var(--bronze)]">
                <td className="py-2.5 font-medium">{r[0]}</td>
                <td className="py-2.5">{r[1]}</td>
                <td className="py-2.5">{r[2]}</td>
                <td className="py-2.5">{r[3]}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </DialogContent>
    </Dialog>
  );
}
